import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		background: colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${spacing.xl}px ${spacing.lg}px`,
		gap: spacing.md,
		boxSizing: 'border-box',
		height: '100%',
	},
	illustrationContainer: {
		display: 'inline-block',
		position: 'relative',
		marginBottom: spacing.sm,
	},
	successCheckIcon: {
		height: 42,
		left: 6,
		position: 'absolute',
		top: '26%',
		width: 42,
		zIndex: 1,
	},
	completedBanner: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm + spacing.xs,
		width: '100%',
		maxWidth: 600,
		padding: `${spacing.md}px ${spacing.md + spacing.xs}px`,
		borderRadius: common.borderRadius,
		background: colors.success.light,
	},
	completedIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: spacing.xxl,
		height: spacing.xxl,
		borderRadius: common.borderRadius,
		background: colors.success.main,
		flexShrink: 0,
	},
	completedText: {
		color: colors.success.dark,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
	remainingCard: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm + spacing.xs,
		width: '100%',
		maxWidth: 600,
		padding: `${spacing.md}px ${spacing.md + spacing.xs}px`,
		borderRadius: common.borderRadius,
		background: colors.background.light,
		boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.08)',
	},
	remainingIcon: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: spacing.xxl,
		height: spacing.xxl,
		borderRadius: common.borderRadius,
		background: colors.primary.main,
		flexShrink: 0,
	},
	remainingText: {
		color: colors.text.main,
		fontSize: typography.fontSizes.sm,
		flex: 1,
	},
	scheduleButton: {
		flexShrink: 0,
	},
	doneContainer: {
		marginTop: spacing.sm,
	},
	doneButton: {
		minWidth: 160,
	},
});
